import { IAgroTechnicalEventById } from '@/features/agro-technical-events/models/IAgroTechnicalEvents';
import useStore from '@/lib/store';
import { useTranslation } from 'react-i18next';

interface InfosProps {
  items: IAgroTechnicalEventById;
  isLoading: boolean;
}

export const Infos = ({ items, isLoading }: InfosProps) => {
  const { t } = useTranslation();
  const { plantsSelect } = useStore();

  return (
    <div className="grid grid-cols-12 gap-y-[29px]">
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('plant.type')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {plantsSelect?.find((o) => o?.value === items?.plant_id)?.label}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('district')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items?.region_name}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('city')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <>
                <p className="text-base text-midnight-default font-medium">
                  {items?.district_name}
                </p>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('area')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items?.area || 0} {t('hectare')}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('remaining.area')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items?.residue_area || 0} {t('hectare')}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">
            {t('areas.with.contours')}:
          </p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items?.contours_area || 0} {t('hectare')}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('current.status')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items?.cotton_yield_current === null
                  ? '0 s'
                  : `${items?.cotton_yield_current} s`}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('plan')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items?.cotton_yield_plan === null
                  ? '0 s'
                  : `${items?.cotton_yield_plan} s`}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex flex-col">
          <p className="text-gray-arsenic text-xs">{t('current.result')}:</p>
          <div className="flex items-center gap-[6px]">
            {isLoading ? (
              <div className="h-6 bg-gray-200 rounded animate-pulse w-32" />
            ) : (
              <p className="text-base text-midnight-default font-medium">
                {items?.cotton_yield_result === null
                  ? '0 s'
                  : `${items?.cotton_yield_result} s`}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
